/**
 * BMAT MediaPlayers Module
 */
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { BMATAudioPlayerComponent } from './audio/bm-audio.component';
import { BMMediaOutputComponent } from './bm-media-output/bm-media-output.component';
import { ConnectedAudioPlayerComponent } from './components/connected-audio-player/connected-audio-player.component';
import { ConnectedVideoPlayerComponent } from './components/connected-video-player/connected-video-player.component';
import { ParseDurationPipeModule } from './format-duration/format-duration.pipe.module';
import { MediaProgressSliderComponentModule } from './media-progress-slider/media-progress-slider.component.module';
import { ProgressBarComponentModule } from './progress-bar/progress-bar.component.module';
import { ConnectedMediaRemoteService } from './services/connected-media-remote/connected-media-remote.service';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    ParseDurationPipeModule,
    ProgressBarComponentModule,
    MediaProgressSliderComponentModule,
  ],
  declarations: [
    BMATAudioPlayerComponent,
    BMMediaOutputComponent,
    ConnectedAudioPlayerComponent,
    ConnectedVideoPlayerComponent,
  ],
  exports: [
    BMATAudioPlayerComponent,
    BMMediaOutputComponent,
    ConnectedAudioPlayerComponent,
    ConnectedVideoPlayerComponent,
    ParseDurationPipeModule,
    ProgressBarComponentModule,
    MediaProgressSliderComponentModule,
  ],
  entryComponents: [
    ConnectedAudioPlayerComponent,
    ConnectedVideoPlayerComponent,
  ],
})
export class BMATMediaPlayersModule {
  // tslint:disable-next-line:function-name
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: BMATMediaPlayersModule,
      providers: [ConnectedMediaRemoteService],
    };
  }
}
